import type { ReactNode } from "react";
import { Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Compact section heading with an optional trailing "See all"-style link, or a
 * short trailing status (`aside`) such as "All clear".
 */
export function SectionHeader({
  id,
  title,
  action,
  aside,
}: {
  id?: string;
  title: string;
  action?: { label: string; to: string; ariaLabel?: string };
  aside?: ReactNode;
}) {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: "baseline", justifyContent: "space-between", px: { xs: 0.5, sm: 0 } }}
    >
      <Typography id={id} component="h2" sx={{ fontSize: "1rem", fontWeight: 700 }}>
        {title}
      </Typography>
      {action ? (
        <Link
          component={RouterLink}
          to={action.to}
          underline="none"
          aria-label={action.ariaLabel}
          sx={{ fontSize: "0.875rem", fontWeight: 600 }}
        >
          {action.label}
        </Link>
      ) : aside ? (
        <Typography variant="body2" color="text.secondary">
          {aside}
        </Typography>
      ) : null}
    </Stack>
  );
}
